import AccountRowTemplate from "./AccountRowTemplate.js";
import GeneratedAccountRow from "../../reports/rows/GeneratedAccountRow.js";

/**
 * Account row that is generated as a child of an account group.
 *
 */
export default class GeneratedAccountRowTemplate extends AccountRowTemplate {
	accept(visitor) {
		return visitor.visitGeneratedAccountRowTemplate(this);
	}

	_instanceClass() {
		return GeneratedAccountRow;
	}

	static isVisible() {
		return false;
	}

	/**
	 * Create and return instances of the receiver, one for each account
	 * in `accounts`. The created row templates are registered as
	 * children of `parent`.
	 *
	 * @param {Account[]} accounts - Each of these accounts will be
	 *   wrapped by a dedicated row template
	 * @param {AbstractAccountGroupRowTemplate} parent - The row
	 *   template which should contain the generated child row
	 *   templates
	 * @return {GeneratedAccountRowTemplate[]}
	 */
	static makeRowTemplatesFromAccounts({ accounts, parent }) {
		return accounts.map((account) => {
			const accountNumber = account.getNumber();

			return new this({
				id: `${parent.getId()}_${accountNumber}`,
				accountNumber,
				reportTemplate: parent.getReportTemplate(),
				parent,
			});
		});
	}
}
